var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.36395 2.67019L12.4273 5.94086L4.67318 14.2199L1.61161 10.9492L9.36395 2.67019ZM14.7517 1.88138L13.3856 0.422776C12.8576 -0.140925 12.0003 -0.140925 11.4706 0.422776L10.162 1.81998L13.2253 5.09068L14.7517 3.46092C15.1612 3.02368 15.1612 2.31859 14.7517 1.88138ZM0.00852446 15.5464C-0.0472238 15.8143 0.1793 16.0544 0.430224 15.9892L3.84376 15.1055L0.782195 11.8348L0.00852446 15.5464Z",
    fill: "#556BB8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditBlue);
export default __webpack_public_path__ + "static/media/edit-blue.1bd23123e8cae9391b1f52a818c5602c.svg";
export { ForwardRef as ReactComponent };